module.exports = __webpack_public_path__ + "static/media/ic-sync-menu-file.29cb6a73.svg";